<template>
    <div class="bao-toggle" @click="toggle">
        <div class="labels font-heading">
            <div class="label label-menu">Order</div>
            <div class="label label-ar">AR</div>
        </div>
        <div class="toggle">
            <div class="icon icon-menu">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="7.505"
                    height="10.376"
                    viewBox="0 0 7.505 10.376"
                >
                    <path
                        id="Path_4"
                        data-name="Path 4"
                        d="M2.094,1.042A1.142,1.142,0,0,1,1.409.695,1.048,1.048,0,0,1,1.177-.02V-6.39a1.088,1.088,0,0,1,.147-.585.8.8,0,0,1,.41-.336,1.183,1.183,0,0,1,.613-.042l4.926.872a2.11,2.11,0,0,1,1.057.437,1.3,1.3,0,0,1,.353,1.018V.55A1.772,1.772,0,0,1,8.5,1.4a1.031,1.031,0,0,1-.522.48,1.423,1.423,0,0,1-.808.055ZM2.97-4.687l3.621.641a.32.32,0,0,0,.279-.069.326.326,0,0,0,.1-.252A.308.308,0,0,0,6.7-4.7L3.1-5.332a.353.353,0,0,0-.287.065A.3.3,0,0,0,2.7-5.02a.35.35,0,0,0,.07.223A.3.3,0,0,0,2.97-4.687Zm0,1.875,3.621.646a.311.311,0,0,0,.279-.065.338.338,0,0,0,.1-.262A.3.3,0,0,0,6.7-2.82L3.1-3.447a.341.341,0,0,0-.287.06A.3.3,0,0,0,2.7-3.14a.338.338,0,0,0,.071.219A.3.3,0,0,0,2.97-2.812Zm.46-5L6.6-8.363a1.721,1.721,0,0,1,1.319.185A1.235,1.235,0,0,1,8.4-7.1v.33a3.307,3.307,0,0,0-1.022-.335Z"
                        transform="translate(-1.177 8.409)"
                    />
                </svg>
            </div>
            <div class="icon icon-ar" @click="toggle">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="9.414"
                    height="10.266"
                    viewBox="0 0 9.414 10.266"
                >
                    <path
                        id="Path_5"
                        data-name="Path 5"
                        d="M5.485,1.666,4.2.938A.444.444,0,0,1,3.973.672.437.437,0,0,1,4.011.345.371.371,0,0,1,4.27.152a.478.478,0,0,1,.348.06L5.466.7V-.2a.474.474,0,0,1,.119-.333.388.388,0,0,1,.3-.13.388.388,0,0,1,.3.13A.474.474,0,0,1,6.3-.2V.7L7.149.213A.478.478,0,0,1,7.5.152a.371.371,0,0,1,.259.193A.435.435,0,0,1,7.8.672a.446.446,0,0,1-.227.266l-1.284.728A.777.777,0,0,1,5.485,1.666ZM2.43-.058,1.849-.383a1.528,1.528,0,0,1-.5-.425,1.306,1.306,0,0,1-.168-.748v-.725a.491.491,0,0,1,.113-.331.368.368,0,0,1,.293-.133.366.366,0,0,1,.283.126.477.477,0,0,1,.12.317l0,.544.7-.4a.446.446,0,0,1,.337-.053.432.432,0,0,1,.266.2.36.36,0,0,1,.039.327A.507.507,0,0,1,3.1-1.41l-.67.381.448.26a.46.46,0,0,1,.2.258.406.406,0,0,1-.03.322.382.382,0,0,1-.266.194A.493.493,0,0,1,2.43-.058Zm-.847-3.65a.372.372,0,0,1-.29-.13.476.476,0,0,1-.116-.329V-5.253a1.164,1.164,0,0,1,.151-.626,1.243,1.243,0,0,1,.445-.411l.974-.548a.531.531,0,0,1,.337-.07.391.391,0,0,1,.276.173.374.374,0,0,1,.069.218.417.417,0,0,1-.067.226.534.534,0,0,1-.192.178L2.439-5.7l.761.429A.5.5,0,0,1,3.445-5a.349.349,0,0,1-.037.324.447.447,0,0,1-.273.2.438.438,0,0,1-.329-.048l-.818-.471v.826a.483.483,0,0,1-.113.329A.369.369,0,0,1,1.583-3.708Zm4.3-2.444a.385.385,0,0,1-.3-.132.476.476,0,0,1-.119-.331v-.8l-.591.333a.5.5,0,0,1-.331.053.355.355,0,0,1-.255-.175.414.414,0,0,1-.047-.33.458.458,0,0,1,.233-.28l.942-.536a.988.988,0,0,1,.468-.138.988.988,0,0,1,.468.138l.941.536a.458.458,0,0,1,.233.28.415.415,0,0,1-.047.33.355.355,0,0,1-.255.175.5.5,0,0,1-.332-.053L6.3-7.417v.8a.476.476,0,0,1-.119.331A.385.385,0,0,1,5.884-6.152Zm4.3,2.444a.363.363,0,0,1-.29-.131.489.489,0,0,1-.111-.329v-.826l-.822.471a.44.44,0,0,1-.329.048.43.43,0,0,1-.268-.2A.349.349,0,0,1,8.328-5a.5.5,0,0,1,.244-.273L9.328-5.7,8.6-6.113a.532.532,0,0,1-.191-.178.418.418,0,0,1-.066-.226.376.376,0,0,1,.069-.218.392.392,0,0,1,.276-.173.53.53,0,0,1,.337.07L10-6.29a1.253,1.253,0,0,1,.462.4,1.222,1.222,0,0,1,.133.633v1.086a.476.476,0,0,1-.116.329A.372.372,0,0,1,10.185-3.708ZM9.338-.058a.492.492,0,0,1-.354.064.368.368,0,0,1-.261-.194.413.413,0,0,1-.032-.322.449.449,0,0,1,.2-.258l.445-.26L8.67-1.41a.506.506,0,0,1-.237-.275.361.361,0,0,1,.039-.327.432.432,0,0,1,.266-.2.445.445,0,0,1,.336.053l.706.4L9.786-2.3A.485.485,0,0,1,9.9-2.618a.359.359,0,0,1,.281-.126.367.367,0,0,1,.292.133.491.491,0,0,1,.113.331v.725a1.307,1.307,0,0,1-.168.748,1.524,1.524,0,0,1-.5.425ZM5.884-1.579a.385.385,0,0,1-.3-.132.476.476,0,0,1-.119-.331v-.979l-.9-.512a.487.487,0,0,1-.239-.278.363.363,0,0,1,.041-.325.428.428,0,0,1,.263-.2.443.443,0,0,1,.334.053l.917.515L6.8-4.278a.445.445,0,0,1,.334-.053.428.428,0,0,1,.263.2.363.363,0,0,1,.041.325.486.486,0,0,1-.239.278l-.9.512v.979a.476.476,0,0,1-.119.331A.385.385,0,0,1,5.884-1.579Z"
                        transform="translate(-1.177 8.489)"
                    />
                </svg>
            </div>

            <div class="highlighter"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaoHeaderToggle',
    methods: {
        toggle() {
            const url = `https://bao.pocketgm.ai/?site=${this.$store.state.venue?.venue?.slug}&table=${this.$store.state.cart?.selectedTableId}`;
            window.location.assign(url);
        }
    }
};
</script>

<style>
/* fix */

.bao-toggle,
.bao-toggle * {
    box-sizing: border-box;
}

/* toggle element */

.bao-toggle {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 4px;
}

/* text label */

.bao-toggle .labels {
    font-size: 12px;
    width: 3.5em;
    height: 1em;
    white-space: nowrap;
    position: relative;
}
.bao-toggle .labels .label {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 3.5em;
    text-align: center;
    transition: 100ms ease-in-out all;
}
.bao-toggle .label-menu {
    opacity: 1;
}
.bao-toggle .label-ar {
    opacity: 0;
}

/* toggle switch ui */

.bao-toggle .toggle {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 3px;
    padding: 3px;
    border-radius: 24px;
    border: 1px solid rgba(0, 0, 0, 0.2);
}
.bao-toggle .icon {
    height: 24px;
    width: 24px;
    border-radius: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 200ms ease-in-out all 100ms;
}
.bao-toggle .icon-menu {
    opacity: 1;
}
.bao-toggle .icon-ar {
    opacity: 0.4;
}
.bao-toggle .icon svg {
    height: 50%;
    width: 50%;
}

/* highlight dot with shadow */

.bao-toggle .highlighter {
    position: absolute;
    left: 3px;
    height: 24px;
    width: 24px;
    border-radius: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2.5px 5px 0px rgba(0, 0, 0, 0.2);
    transition: 200ms ease-in-out all;
}

/* hover styles */

.bao-toggle:hover .highlighter {
    left: calc(3px + 3px + 24px);
}
.bao-toggle:hover .icon-menu {
    opacity: 0.4;
}
.bao-toggle:hover .icon-ar {
    opacity: 1;
}
.bao-toggle:hover .label-menu {
    opacity: 0;
}
.bao-toggle:hover .label-ar {
    opacity: 1;
}
</style>
